import { render, staticRenderFns } from "./BarOrderModeDelivery.vue?vue&type=template&id=459536d7&scoped=true&"
import script from "./BarOrderModeDelivery.vue?vue&type=script&lang=js&"
export * from "./BarOrderModeDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459536d7",
  null
  
)

export default component.exports